import {
  minBreakpoints,
  primaryRegularFont,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { getContentstackImageURL } from '@noths/polaris-client-utils';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

const backgroundImageWithGradient = (imgURL: string) => {
  return css`
    background-image: linear-gradient(180deg, rgba(30, 30, 41, 0) 30%, rgba(30, 30, 41, 0.9) 80%),
      url('${imgURL}');
  `;
};

export const root = (backgroundImageUrl: string) => {
  const backgroundImage = {
    DEFAULT: getContentstackImageURL(backgroundImageUrl, 768, { aspectRatio: '3:2' }),
    M: getContentstackImageURL(backgroundImageUrl, 1024, { aspectRatio: '3:2' }),
    L: getContentstackImageURL(backgroundImageUrl, 1440, { aspectRatio: '2:1' }),
  };

  return css`
    display: grid;
    grid-template-rows: 100px auto;
    grid-row-gap: ${spacing.sm}px;
    grid-template-areas:
      'logo'
      'content';
    border-radius: ${spacing.sm}px;
    padding: ${spacing.xl}px;
    max-width: 1440px;
    min-height: 492px;
    ${backgroundImageWithGradient(backgroundImage.DEFAULT)};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 0;
    color: #fff;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        grid-column-gap: ${spacing.sm}px;
        min-height: 368px;
        ${backgroundImageWithGradient(backgroundImage.M)};
      `,
    )};

    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        min-height: 385px;
        ${backgroundImageWithGradient(backgroundImage.L)};
      `,
    )};
  `;
};

export const logo = css`
  grid-area: logo;
  max-width: 300px;
`;

export const content = css`
  grid-area: content;
  align-self: end;

  p {
    margin: 0;
    ${primaryRegularFont};
    ${responsiveText.BODY.MD};
    padding: 0 0 ${spacing.xs}px 0;
    color: var(--neutral-white-base);

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        padding: 0 ${spacing.lg}px 0 0;
      `,
    )};
  }
`;

export const heading = css`
  margin: 0 0 ${spacing.xs}px;
  ${primarySemiBoldFont};
  ${responsiveText.HEADING.LG};
`;

export const body = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex-direction: row;
    `,
  )};
`;

export const button = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      max-width: 280px;
      min-width: 200px;
      align-self: end;
    `,
  )};
`;
